import { useLoaConsultContext } from "../../../Contexts/LoaConsultContext";
import dayjs from "dayjs";

function Summary() {

  const { formData } = useLoaConsultContext();

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-1">
        LOA request summary
      </p>
      <p className="text-[#60656D] mb-4">
        The LOA is valid for 3 days. Review your LOA request details.
      </p>
      <div className="mb-2">
        <p className="font-semibold mb-1">Hospital name</p>
        <p className="capitalize">
          {formData.hospitalName.providerName.toLowerCase()}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Specialization</p>
        <p className="capitalize">{formData.specialization.toLowerCase()}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Name of requesting doctor</p>
        <p className="capitalize">
          {formData.requestingDoctorName.Physician?.split(":")[0].toLowerCase() || ""}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Requested date</p>
        <p className="capitalize">{dayjs().format("MMMM DD, YYYY")}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Chief complaint</p>
        <p>{formData.chiefComplaint}</p>
      </div>
    </div>
  );
}

export default Summary;